import React from 'react';
import cn from 'classnames';

import styles from './styles.module.scss';
import { IProps } from './types';
import { useTranslation } from 'react-i18next';
// const imgArrowMore = `/assets/img/login/arrowMore.svg`;

export const AdvertisementContent = ({ item, disableClick, horizontalView }: IProps) => {
  const { t } = useTranslation();

  const handleClick = () => {
    if (!disableClick) {
      window.open(item.url, '_blank');
    }
  };

  return (
    <div className={cn(styles.content, horizontalView && styles.content_horizontalView)}>
      <div
        className={cn(styles.img, styles.content__img)}
        style={{
          backgroundImage: `url(${item.background})`,
          backgroundPosition: item.backgroundPosition,
        }}
      />

      <div className={styles.content__info}>
        <div className={cn(styles.content__info__title, !horizontalView && 'mb-2')}>{t(item.title)}</div>
        <div className={styles.content__info__main}>{t(item.main)}</div>
        <button className={cn(styles.content__info__url, styles.btn)} onClick={handleClick}>
          <div>{t('auth:readMore')}</div>
          {/* <img src={imgArrowMore} className={styles.content__info__arrow} alt='>' /> */}
        </button>
      </div>
    </div>
  );
};
